export function loadPayment() {
	return new Promise((resolve) => {
		if (window.PaymentJS) {
			resolve(window.PaymentJS);
			return;
		}

		const script = document.createElement('script');
		script.src = 'https://gateway.ixopay.com/js/integrated/payment.1.3.min.js';
		script.dataset.main = 'payment-js';

		script.onload = () => {
			return resolve(window.PaymentJS);
		};
		script.onerror = () => {
			resolve(null);
			return;
		};

		document.head.appendChild(script);
	});
}
